<div class="grid">
  <div class="col">
    <p-button label="Reset" size="small" severity="primary" icon="pi pi-refresh" (click)="reset()"> </p-button>
  </div>
</div>
<div class="flex flex-column gap-3">
  <div class="flex items-center">
    <p-radiobutton inputId="buildmyownschedule" [(ngModel)]="buildMyOwnSchedule" [value]="true" (ngModelChange)="onBuildMyOwnSelected()" />
    <label for="buildmyownschedule" class="ml-2">Build my own schedule</label>
  </div>
  <div class="flex items-center">
    <p-radiobutton inputId="recurringschedule" [(ngModel)]="buildMyOwnSchedule" [value]="false" (ngModelChange)="onBuildMyOwnSelected()" />
    <label for="recurringschedule" class="ml-2">Recurring Schedule</label>
  </div>
</div>
<div *ngIf="!buildMyOwnSchedule" class="mt-4">
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-datepicker
          class="required"
          id="deliveryDate"
          [(ngModel)]="firstDeliveryDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          showIcon
          iconDisplay="input"
          data-testId="firstDeliveryDate"
          appendTo="body"
          (ngModelChange)="firstDeliveryDateChanged()"
          [disabledDays]="invalidDays"
          [disabledDates]="invalidDates"></p-datepicker>
        <label for="firstDeliveryDate">First Delivery Date</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid mt-1">
    <div class="col">
      <p-floatlabel variant="on">
        <p-datepicker
          class="required"
          id="deliveryDate"
          [(ngModel)]="stopDate"
          [minDate]="firstDeliveryDate"
          [maxDate]="maxDate"
          showIcon
          iconDisplay="input"
          data-testId="lastDeliveryDate"
          appendTo="body"
          [disabledDays]="invalidDays"
          [disabledDates]="invalidDates"
          [disabled]="lastDeliveryDateDisabled"></p-datepicker>
        <label for="lastDeliveryDate">Last Delivery Date</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid mt-1">
    <div class="col">
      <div class="flex align-items-center gap-2">
        Repeat Every:
        <p-inputnumber
          [(ngModel)]="repeatInterval"
          [useGrouping]="false"
          min="1"
          class="width-3 required"
          inputId="repeatinterval"
          data-testid="repeatinterval" />
        <p-select
          class="required"
          [(ngModel)]="repeatUnit"
          [options]="repeatUnitOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          inputId="repeatUnit">
        </p-select>
      </div>
    </div>
  </div>
  <div class="grid mt-1">
    <div class="col" [style.color]="selectedWeekDays.length === 0 ? 'var(--res-color-red)' : 'var(--res-color-green)'">Select Days:</div>
  </div>
  <div class="grid">
    <div
      class="col flex align-items-center"
      [ngStyle]="{
        border: '2px solid ' + (selectedWeekDays.length === 0 ? 'var(--res-color-red)' : 'var(--res-color-green)'),
        borderRadius: '6px'
      }">
      <div class="flex gap-2">
        <button
          *ngFor="let day of weekDays"
          [class.selected]="selectedWeekDays.includes(day.value)"
          (click)="toggleWeekDay(day.value)"
          type="button"
          style="width: 2rem; height: 2rem; border-radius: 50%; border: 1px solid #ccc">
          {{ day.label }}
        </button>
      </div>
    </div>
  </div>
  <div class="grid mt-1">
    <div class="col">
      <p-button label="Build Schedule" (click)="buildSchedule()" severity="primary" icon="pi pi-calendar" [disabled]="!canBuildSchedule()">
      </p-button>
    </div>
  </div>

  <div class="grid mt-1" *ngIf="invalidRecurrenceDates.length > 0">
    <div class="col">
      <div><strong>Invalid Dates:</strong></div>
      <p-listbox
        [options]="invalidRecurrenceDates"
        [style]="{ width: '200px', height: '150px', 'overflow-y': 'auto', display: 'block' }"
        [highlightOnSelect]="false"
        listStyleClass="w-full"
        class="w-full">
        <ng-template pTemplate="header">
          <div class="flex">
            <p-button icon="pi pi-trash" label="Remove Invalid" size="small" (click)="removeInvalid()" />
          </div>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <span class="invalid-date">{{ option.label || option }}</span>
        </ng-template>
      </p-listbox>
    </div>
  </div>
</div>
